export default __webpack_public_path__ + "static/media/a-rush-of-blood-to-the-head.a4c62573.jpg";